/**
 * @generated SignedSource<<1451d9f844c63dcf58db821c63156a86>>
 * @relayHash 16d53f7129f5cf8fe2d89444bcbb1c67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0a8f1df16b35a8294beac1eb2ffc2da48620f2b541f878e380857b8ee5bef211

import type { ConcreteRequest, Query } from 'relay-runtime';
export type AiRelatedIssuesResourcesEntrypointIssueLinkTypesQuery$variables = {
  cloudId: string;
};
export type AiRelatedIssuesResourcesEntrypointIssueLinkTypesQuery$data = {
  readonly jira: {
    readonly issueLinkTypes: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly inwards: string | null | undefined;
          readonly linkTypeId: string | null | undefined;
          readonly outwards: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type AiRelatedIssuesResourcesEntrypointIssueLinkTypesQuery = {
  response: AiRelatedIssuesResourcesEntrypointIssueLinkTypesQuery$data;
  variables: AiRelatedIssuesResourcesEntrypointIssueLinkTypesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "linkTypeId"
},
v3 = {
  "kind": "ScalarField",
  "name": "inwards"
},
v4 = {
  "kind": "ScalarField",
  "name": "outwards"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AiRelatedIssuesResourcesEntrypointIssueLinkTypesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssueLinkTypeConnection",
            "kind": "LinkedField",
            "name": "issueLinkTypes",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueLinkTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueLinkType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AiRelatedIssuesResourcesEntrypointIssueLinkTypesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssueLinkTypeConnection",
            "kind": "LinkedField",
            "name": "issueLinkTypes",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueLinkTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueLinkType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0a8f1df16b35a8294beac1eb2ffc2da48620f2b541f878e380857b8ee5bef211",
    "metadata": {},
    "name": "AiRelatedIssuesResourcesEntrypointIssueLinkTypesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a79367460c47600da9af540e99c37839";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
